import Vapi from "@vapi-ai/web";
import { useEffect, useRef, useState } from "react";

const ASSISTANT_ID = "1efcd159-c62d-49fc-9cde-1af4da1415b7";
const PUBLIC_KEY = "cf391398-271e-4a59-a345-76a24fca452a";

export function useCallCallie() {
  const vapiRef = useRef(null);
  const [callActive, setCallActive] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    const vapi = new Vapi(PUBLIC_KEY);
    vapiRef.current = vapi;

    vapi.on("call-start", () => { setCallActive(true); setStatus("Connected"); });
    vapi.on("call-end", () => { setCallActive(false); setStatus(""); });
    vapi.on("speech-start", () => setStatus("Callie is speaking..."));
    vapi.on("speech-end", () => setStatus("Connected"));
    vapi.on("error", (e) => {
      console.error(e);
      setCallActive(false);
      setStatus("Something went wrong. Try again.");
    });

    return () => {
      vapi.stop();
    };
  }, []);

  async function toggle() {
    if (!vapiRef.current) return;
    if (callActive) {
      vapiRef.current.stop();
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((t) => t.stop());
      } catch {
        setStatus("Microphone access is required to talk to Callie.");
        return;
      }
      setStatus("Connecting...");
      vapiRef.current.start(ASSISTANT_ID);
    }
  }

  return { toggle, callActive, status };
}
